import { render, staticRenderFns } from "./editmember.vue?vue&type=template&id=4fa851a0&"
import script from "./editmember.vue?vue&type=script&lang=js&"
export * from "./editmember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports